import axios from "axios";

export const getCreds = () => {
  let env = localStorage.getItem("env") || "dev";
  let clientId = process.env.REACT_APP_CLIENT_ID;
  let clientSecret = process.env.REACT_APP_CLIENT_SECRET;
  let baseUrl = process.env.REACT_APP_ENDPOINT;

  return {
    client_id: clientId,
    client_secret: clientSecret,
    base_url: baseUrl,
  };
};

export const api = () => {
  const creds = getCreds();
  // console.log(creds);
  return axios.create({
    baseURL: creds.base_url,
    auth: {
      username: creds.client_id,
      password: creds.client_secret,
    },
  });
};

// only for login/signup apis - no auth req
export const authApi = () => {
  const creds = getCreds();
  // console.log(creds);
  return axios.create({
    baseURL: creds.base_url,
  });
};
// export default api;
